<template>
  <form-layout label="振込明細">
    <div class="d-flex flex-column gap-2">
      <div class="row row-cols-auto" v-for="issue in issues" :key="issue.id">
        <div class="col-4">
          <div class="row">
            <div class="col">{{ issue.file_name }}</div>
          </div>
          <div class="row">
            <div class="col">{{ issue.uploaded_at }}</div>
          </div>
        </div>
        <a :href="issue.path" target="_blank" class="col">
          <confirm-button type="button" class="btn-sm btn-light border-dark px-4" />
        </a>
        <div class="col">
          <delete-button class="btn-sm px-4" @click="doDelete(issue)" />
        </div>
      </div>
      <div class="row row-cols-auto" >
        <div class="col">
          <span class="p-0" v-if="this.issues < 1">選択されていません</span>
        </div>
      </div>
      <div class="row row-cols-auto" >
        <file-upload-common ref="fileUpload" :file-name="null" :upload="upload" @dataInput="handleUpload" />
      </div>
      <div class="invalid-feedback" :class="errorMessage ? 'd-block' : ''" v-for="error in errorMessage" :key="error.id">
        <div>{{ error.name ? error.name + ' -' : '' }}  {{ error.transfer_statement_file?.[0] }}</div>
      </div>
    </div>
  </form-layout>
</template>

<script>
import FormLayout from '@/views/templates/FormLayout';
import ConfirmButton from '@/views/molecules/buttons/ConfirmButton';
import DeleteButton from '@/views/molecules/buttons/DeleteButton';
import FileUploadCommon from '@/views/atoms/inputs/FileUploadCommon';

export default {
  name: "VuexMultiFileUploadFormItem",
  components: {
    FormLayout,
    ConfirmButton,
    DeleteButton,
    FileUploadCommon,
  },
  inject: [
    '$constant'
  ],
  props: {
    issues: {
      type: Array,
      default: () => {
        return []
      }
    },
    setUploadFileHandler: {
      type: Function,
      default: () => {
      }
    },
    errorMessage: {
      type: Array,
      default: () => {
        return []
      }
    },
    upload: {
      type: Function,
      default: () => {
      }
    },
    resetErrors: {
      type: Function,
      default: () => {
      }
    },
    callback:{
      type: Function,
      default: () => {
      }
    }
  },
  emits: ['delete'],
  methods: {
    doDelete(issue) {
      this.$emit('delete', { id: issue.id });
    },
    handleUpload: async function(payload) {
      this.resetErrors();
      let array = Array.from(payload);
      if (array.length > 5) {
        return this.upload(false);
      } else {
        for (let file of array) {
          await this.upload(file);
        }
        this.callback(!this.errorMessage.length);
      }
    },
  },
}
</script>
